module.exports = __webpack_public_path__ + "img/logo3.1f4337ee.png";